<div class="rs-dialog">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h2 class="title" mat-dialog-title>
      Add Action
      <span class="right-buttons">
        <button type="button" app-mat-icon-button (click)="onCancel()" matTooltip="Cancel" tabindex="-1">
          <span class="ri-cancel icon-button grey-icon"></span>
        </button>
      </span>
    </h2>
    <div>
      <div class="row">
        <div class="col-6">
          <app-mat-form-field>
            <input appMatInput type="text" formControlName="name" placeholder="Name" />
            <app-mat-error *ngIf="form && form?.get('name')?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>
        <div class="col-6">
          <app-mat-form-field>
            <app-mat-label>Source</app-mat-label>
            <app-mat-select formControlName="source">
              <app-mat-option *ngFor="let source of sources" [value]="source.type">
                {{ source.text }}
              </app-mat-option>
            </app-mat-select>
            <app-mat-error *ngIf="form && form?.get('source')?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>
        <div class="col-6">
          <app-mat-form-field>
            <input appMatInput type="text" formControlName="value" placeholder="Value" />
            <app-mat-error *ngIf="form && form?.get('value')?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>
        <div class="col-6">
          <app-mat-form-field>
            <input appMatInput type="text" formControlName="defaultValue" placeholder="Default value" />
            <app-mat-error *ngIf="form && form?.get('defaultValue')?.errors?.['required']">Required</app-mat-error>
          </app-mat-form-field>
        </div>
      </div>
    </div>
    <div class="footer">
      <button app-mat-flat-button color="primary" (clicked)="onSubmit()">
        <span>Save</span>
      </button>
    </div>
  </form>
</div>
